import { useState } from "react";
import { Download, Trash2, X, ChevronDown } from "lucide-react";
import useQuoteStatuses from "../../hooks/useQuoteStatuses";

export default function QuoteBulkToolbar({
  t, selectedCount, busy, error,
  onChangeStatus, onExportZip, onDelete, onClear,
}) {
  const [statusMenuOpen, setStatusMenuOpen] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const apiStatuses = useQuoteStatuses();
  const BULK_STATUS = apiStatuses.map((s) => ({
    v: s.id,
    label: t(`status.${s.id}`, { defaultValue: s.label_it }),
  }));

  const handleStatus = (v) => {
    setStatusMenuOpen(false);
    onChangeStatus(v);
  };

  const handleDelete = () => {
    setConfirmDelete(false);
    onDelete();
  };

  return (
    <div className="px-6 py-3 border-b border-blue-500/40 bg-blue-500/5 flex items-center justify-between flex-wrap gap-3" data-testid="bulk-toolbar">
      <div className="text-sm text-blue-200 font-mono-data">
        <span data-testid="bulk-count">{selectedCount}</span> {t("dashboard.selected", { count: selectedCount })}
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        <div className="relative">
          <button
            onClick={() => setStatusMenuOpen((s) => !s)}
            disabled={busy}
            className="px-3 py-1.5 rounded-md text-sm bg-slate-800 hover:bg-slate-700 text-slate-100 border border-slate-700 flex items-center gap-1 disabled:opacity-50"
            data-testid="bulk-status-btn"
          >
            {t("dashboard.changeStatus")} <ChevronDown size={14}/>
          </button>
          {statusMenuOpen && (
            <div className="absolute right-0 mt-1 w-44 rounded-md bg-slate-900 border border-slate-700 shadow-xl z-50 overflow-hidden" data-testid="bulk-status-menu">
              {BULK_STATUS.map((s) => (
                <button key={s.v} onClick={() => handleStatus(s.v)} className="w-full text-left px-3 py-2 text-sm text-slate-100 hover:bg-slate-800" data-testid={`bulk-status-${s.v}`}>
                  {s.label}
                </button>
              ))}
            </div>
          )}
        </div>
        <button onClick={onExportZip} disabled={busy} className="px-3 py-1.5 rounded-md text-sm bg-blue-600 hover:bg-blue-500 text-white flex items-center gap-1 disabled:opacity-50" data-testid="bulk-export-zip-btn">
          <Download size={14}/> {t("dashboard.exportZip")}
        </button>
        {!confirmDelete ? (
          <button onClick={() => setConfirmDelete(true)} disabled={busy} className="px-3 py-1.5 rounded-md text-sm bg-red-600/10 hover:bg-red-600/20 text-red-300 border border-red-500/40 flex items-center gap-1 disabled:opacity-50" data-testid="bulk-delete-btn">
            <Trash2 size={14}/> {t("common.delete")}
          </button>
        ) : (
          <div className="flex items-center gap-1" data-testid="bulk-delete-confirm">
            <button onClick={handleDelete} disabled={busy} className="px-3 py-1.5 rounded-md text-sm bg-red-600 hover:bg-red-500 text-white flex items-center gap-1" data-testid="bulk-delete-yes">
              <Trash2 size={14}/> {t("dashboard.confirmDeleteN", { n: selectedCount })}
            </button>
            <button onClick={() => setConfirmDelete(false)} className="px-3 py-1.5 rounded-md text-sm bg-slate-800 hover:bg-slate-700 text-slate-200 border border-slate-700">{t("common.cancel")}</button>
          </div>
        )}
        <button onClick={onClear} className="px-3 py-1.5 rounded-md text-sm text-slate-400 hover:text-slate-100 flex items-center gap-1" data-testid="bulk-clear-btn">
          <X size={14}/>
        </button>
      </div>
      {error && <div className="w-full text-xs text-red-300" data-testid="bulk-error">{error}</div>}
    </div>
  );
}
